import _ from "underscore";
import CommonImage from "../CommonCompo/CommonImage/CommonImage";
import { useInventoryHistory } from "../../Hooks/Features/InventoryDashboard/useInventoryHistory";
import { SkeletonContainer } from "../Loader/Loader"
import { AgGridReact } from "@ag-grid-community/react";
import { Dialog } from "primereact/dialog";

const InventoryHistory = ({ editData }) => {

    const { colDef, historyData, loader, media, setMedia, rowClassRules } = useInventoryHistory({ editData })

    return (
        <div>
            {loader ? <div style={{ height: "20vh" }}><SkeletonContainer /></div> :
                <div className="ag-theme-alpine mt-2" style={{ height: historyData?.length * 10 + "vh", maxHeight: "50vh" }}>
                    <AgGridReact rowData={historyData} columnDefs={colDef} rowHeight={30} headerHeight={30} rowClassRules={rowClassRules} />
                </div>
            }

            <Dialog className="modal-medium" visible={media?.visible} onHide={() => setMedia({ visible: false, data: {} })} draggable={false} header="Media">
                <div>
                    <div className="d-flex justify-content-between align-items-center fw-bold fs-6" style={{ backgroundColor: "#e7e7e7" }}>
                        <div className="w20 text-center pb-1 pt-1">
                            ASSET
                        </div>
                        <div className="w40 text-center pb-1 pt-1">
                            ASSIGN
                        </div>
                        <div className="w40 text-center pb-1 pt-1">
                            RECEIVE
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className={`w20 text-center ${editData?.asset_unique_id === media?.data?.pr_asset_unique_id ? "text-danger" : "text-black"}`}>
                            {media?.data?.pr_asset_unique_id}
                        </div>
                        <div className="w40 border-start border-end ps-2 pb-2">
                            <CommonImage type="display" height="50px" width="50px" selectedImages={media?.data?.media?.assign} />
                        </div>
                        <div className="w40 ps-2 pb-2">
                            <CommonImage type="display" height="50px" width="50px" selectedImages={media?.data?.media?.return} />
                        </div>
                    </div>
                    {media?.data?.child?.map((item, index) => (
                        <div className="d-flex justify-content-between align-items-center" key={index} style={{ backgroundColor: index % 2 === 0 ? "#f5f5f5" : "transparent" }}>
                            <div className={`w20 text-center ${editData?.asset_unique_id === item?.ch_asset_unique_id ? "text-danger" : "text-black"}`}>
                                {item?.ch_asset_unique_id}
                            </div>
                            <div className="w40 border-start border-end ps-2 pb-2">
                                <CommonImage type="display" height="50px" width="50px" selectedImages={item?.media?.assign} />
                            </div>
                            <div className="w40 ps-2 pb-2">
                                <CommonImage type="display" height="50px" width="50px" selectedImages={item?.media?.return} />
                            </div>
                        </div>
                    ))}
                </div>
            </Dialog>
        </div>
    )
}

export default InventoryHistory